window.onload = function() {
    $(document).ready(function($) {
        $(document).on('click', '.js-cd-panel-trigger', function(event) {
            event.preventDefault();

            var $trigger = $(this);
            var panelClass = '.js-cd-panel-' + $trigger.data('panel');
            var $panel = $(panelClass);

            if ($panel.hasClass('cd-panel--is-visible')) {
                $panel.removeClass('cd-panel--is-visible');
            } else if (!$panel.hasClass('cd-panel--disabled')) {
                $panel.addClass('cd-panel--is-visible');
            }
        });
    });
};
